<template>
  <router-link to="/" class="logo_wrapper">
    <img src="@/assets/img/logo.svg" alt="" class="logo_image"/>
  </router-link>
</template>

<script>
export default {
  name: 'Logo'
};
</script>

<style lang="scss">
.logo_wrapper {
  position: fixed;
  left: 60px;
  top: 50px;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 85px;
  background-color: #ffffff;
  cursor: pointer;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  z-index: 200;

  @include media("<=tablet", "landscape") {
    left: 10px;
    top: 38px;
  }
  @include media("<tablet") {
    width: 88px;
    height: 73px;
  }

  .logo_image {
    display: flex;
    flex-direction: column;
    width: 90px;
    height: 71px;
    @include media("<tablet") {
      width: 72px;
      height: 57px;
    }
  }

  .homescreen & {
    @include media("<tablet") {
      position: fixed;
      display: flex;
      flex-direction: column;
      top: 38px;
      left: 10px;
      background-color: #ffffff;
    }
    @include media("<=tablet", "landscape") {
      position: fixed;
      display: flex;
      flex-direction: column;
      top: 38px;
      left: 10px;
      background-color: #ffffff;
    }
  }

  @include media("<tablet") {
    position: relative;
    top: 0;
    //left: 0;
    left: -10px;
    height: 65px;
    display: flex;
    flex-direction: column;
    background: transparent;
  }
}
</style>
